import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser';
import ReactGA from 'react-ga'
import './Splash.css'

class Splash extends Component{

  componentDidMount(){
    ReactGA.initialize(this.props.rest.ga_id)
    ReactGA.pageview('Splash');
    this.shouldUpdateRoute = false
    this.delayRouteUpdating()
  }

  delayRouteUpdating(){
    window.setTimeout(() => {
      this.shouldUpdateRoute = true
    }, 2000);
  }

  componentDidUpdate(prevProps){
    if (this.props.isVisible && !prevProps.isVisible && !this.props.doNotUpdateRoute && this.shouldUpdateRoute){
      this.props.setRoute('')
    }
  }

  handleClick(){
    ReactGA.event({
      category: this.props.rest.name,
      action: 'Order Online',
      label: 'Splash Page'
    })
  }

  renderHeader(){
    if (this.props.rest.splash.logo){
      let imgstyle = null
      if (this.props.rest.splash.logo_width && window.innerWidth > 800){
        imgstyle = {width:this.props.rest.splash.logo_width}
      }
      return(
        <img
          src={this.props.rest.splash.logo}
          className='SplashLogo'
          style={imgstyle}
          alt='rest_logo'
        />
      )
    } else {
      return <div className='SplashHeader'>{this.props.rest.splash.header}</div>
    }
  }

  render(){
    let order_link = this.props.rest.ordering_url ? this.props.rest.ordering_url + this.props.rest.utms : '/location'
    let pickup_link = this.props.rest.ordering_url ? this.props.rest.ordering_url + this.props.rest.utms : '/location'
    if (pickup_link.includes('?')){
      pickup_link = pickup_link + '&order_type=pickup'
    } else {
      pickup_link = pickup_link + '?order_type=pickup'
    }
    let delivery_link = this.props.rest.ordering_url ? this.props.rest.ordering_url + this.props.rest.utms : '/location'
    if (delivery_link.includes('?')){
      delivery_link = delivery_link + '&order_type=delivery'
    } else {
      delivery_link = delivery_link + '?order_type=delivery'
    }
    if (this.props.rest.splash.orientation === 'horizontal'){
      return(
        <div className="SplashContainerHorizontal">
          <div className='SplashSubHeaderHorizontal'>
            {ReactHtmlParser(this.props.rest.splash.subheader)}
            <a href={pickup_link} rel={this.props.rest.ordering_url && "noopener noreferrer"} target={this.props.rest.ordering_url && "_blank"} style={{zIndex:1, width:'100%'}}>
              <button onClick={()=>this.handleClick()} className='SplashButton' style={{background:this.props.rest.hex_color_secondary}}>ORDER PICKUP</button>
            </a>
            <a href={delivery_link} rel={this.props.rest.ordering_url && "noopener noreferrer"} target={this.props.rest.ordering_url && "_blank"} style={{zIndex:1, width:'100%'}}>
              <button onClick={()=>this.handleClick()} className='SplashButton' style={{background:this.props.rest.hex_color_secondary}}>ORDER DELIVERY</button>
            </a>
          </div>
          <img src={this.props.rest.splash.logo} className='SplashLogoHorizontal' alt='rest_logo'/>
        </div>
      )
    }
    else {
      return(
        <div className="SplashContainer">
          {this.renderHeader()}
          <div className='SplashSubHeader'>{ReactHtmlParser(this.props.rest.splash.subheader)}</div>
          <a href={order_link} rel={this.props.rest.ordering_url && "noopener noreferrer"} target={this.props.rest.ordering_url && "_blank"} style={{zIndex:1, width:'100%'}}>
            <button onClick={()=>this.handleClick()} className='SplashButton' style={{background:this.props.rest.hex_color_secondary}}>ORDER ONLINE</button>
          </a>
          <img src='./icons/down.png' className='SplashDownArrow' onClick={()=>this.props.scrollToSection()} alt='arrow-down'/>
        </div>
      )
    }
  }
}

export default Splash;
